export default __webpack_public_path__ + "static/media/rectangle.6f2f3eaf.png";